import { toString as toString_1, Record, Union } from "../../fable_modules/fable-library-js.4.24.0/Types.js";
import { obj_type, option_type, record_type, bool_type, class_type, union_type, int32_type } from "../../fable_modules/fable-library-js.4.24.0/Reflection.js";
import { DocumentRevisionForm_$reflection, DocumentRevisionForm, DocumentScanResult_$reflection, DocumentUploadForm_$reflection, DocumentUploadForm, DocumentForm, DocumentForm_get_Empty, Account_$reflection, DocumentForm_$reflection } from "../../Shared/ApiDataTypes.js";
import { tryStr, tryWith, Documents_DocumentSource_FromId_Z524259A4, Documents_maxUploadSizeKB, Documents_maxUploadDocumentCount, Documents_DocumentSource, Documents_DocumentSource__get_Id, urlDataBytes } from "../../Shared/Shared.js";
import { join, isNullOrWhiteSpace, printf, toText } from "../../fable_modules/fable-library-js.4.24.0/String.js";
import { iterate, empty, singleton, append, delay, toList, map } from "../../fable_modules/fable-library-js.4.24.0/Seq.js";
import { parse as parse_1, toString } from "../../fable_modules/fable-library-js.4.24.0/Date.js";
import { parse as parse_3, newGuid } from "../../fable_modules/fable-library-js.4.24.0/Guid.js";
import { bind, toArray as toArray_1, value as value_314, unwrap, map as map_2, defaultArg, some } from "../../fable_modules/fable-library-js.4.24.0/Option.js";
import { FSharpResult$2 } from "../../fable_modules/fable-library-js.4.24.0/Result.js";
import { createElement } from "react";
import React from "react";
import * as react from "react";
import { reactApi } from "../../fable_modules/Feliz.2.8.0/Interop.fs.js";
import { ctx as ctx_1 } from "../../Context.js";
import { MuiHelpers_createElement } from "../../fable_modules/Feliz.MaterialUI.5.13.7-alpha.8/Mui.fs.js";
import { ListItemSecondaryAction, Link, Collapse, ListItemText, ListItem, List, IconButton, DialogActions, Button, Alert, DialogContent, DialogTitle, Dialog, Checkbox, FormControlLabel, Typography, TextField, Paper } from "@mui/material";
import { comparePrimitives, equals, int32ToString, uncurry2, defaultOf, createObj } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { parse } from "../../fable_modules/fable-library-js.4.24.0/Int32.js";
import { cons, empty as empty_1, singleton as singleton_1, toArray, ofArray } from "../../fable_modules/fable-library-js.4.24.0/List.js";
import { sortByDescending, find, maxBy, head, sortDescending, tryHead, map as map_1 } from "../../fable_modules/fable-library-js.4.24.0/Array.js";
import { useEffectOnce } from "../../fable_modules/Feliz.2.8.0/Internal.fs.js";
import { condDisabledTooltip, wrapTooltip, loadingIndicatorSmall, loadingIndicator, errorBanner } from "../../ViewHelpers.js";
import { rangeDouble } from "../../fable_modules/fable-library-js.4.24.0/Range.js";
import Error$ from "@mui/icons-material/Error";
import Warning from "@mui/icons-material/Warning";
import Check from "@mui/icons-material/Check";
import { Components_TimedProgress_ZB2B7FD7 } from "../TimedProgress.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";
import { defaultOf as defaultOf_1 } from "../../fable_modules/fable-library-js.4.24.0/Util.js";
import { API_Document_Document, API_Document_DownloadVersion, generateQueryString } from "../../Shared/Urls.js";
import { Auto_generateBoxedEncoderCached_437914C6, Auto_generateBoxedEncoder_437914C6 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { Auto_generateBoxedDecoderCached_Z6670B51, Auto_generateBoxedDecoder_Z6670B51 } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { FetchError } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { Helper_fetch, Helper_withContentTypeJson, Helper_withProperties } from "../../fable_modules/Thoth.Fetch.3.0.1/Fetch.fs.js";
import { corsProps } from "../../Promises.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { keyValueList } from "../../fable_modules/fable-library-js.4.24.0/MapUtil.js";
import { toString as toString_2 } from "../../fable_modules/Thoth.Json.10.2.0/Encode.fs.js";
import { fromString } from "../../fable_modules/Thoth.Json.10.2.0/Decode.fs.js";
import { mapFetchError } from "../../Promises.js";
import { getDocumentUploader } from "../../Documents/DocumentHelpers.js";
import ArrowRightAlt from "@mui/icons-material/ArrowRightAlt";
import PriorityHigh from "@mui/icons-material/PriorityHigh";
import { toDateAndTimeStr } from "../../Locale.js";
import { parse as parse_2 } from "../../fable_modules/fable-library-js.4.24.0/DateOnly.js";
import ExpandLess from "@mui/icons-material/ExpandLess";
import ExpandMore from "@mui/icons-material/ExpandMore";
import { CategorySelection } from "./CategorySelect.js";
import VisibilityOff from "@mui/icons-material/VisibilityOff";
import Visibility from "@mui/icons-material/Visibility";
import PanTool from "@mui/icons-material/PanTool";
import { Audits_List_259D9DD2 } from "./Audits.js";
import Edit from "@mui/icons-material/Edit";

export class UploadTarget extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Machine", "Customer"];
    }
}

export function UploadTarget_$reflection() {
    return union_type("Components.Documents.UploadTarget", [], UploadTarget, () => [[["Item", int32_type]], [["Item", int32_type]]]);
}

export class Form extends Record {
    constructor(TmpId, Scanned, Document$) {
        super();
        this.TmpId = TmpId;
        this.Scanned = Scanned;
        this.Document = Document$;
    }
}

export function Form_$reflection() {
    return record_type("Components.Documents.Form", [], Form, () => [["TmpId", class_type("System.Guid")], ["Scanned", bool_type], ["Document", DocumentForm_$reflection()]]);
}

export class FormMeta extends Record {
    constructor(Uploaded, Uploader, ContentSizeBytes) {
        super();
        this.Uploaded = Uploaded;
        this.Uploader = Uploader;
        this.ContentSizeBytes = (ContentSizeBytes | 0);
    }
}

export function FormMeta_$reflection() {
    return record_type("Components.Documents.FormMeta", [], FormMeta, () => [["Uploaded", class_type("System.DateTime")], ["Uploader", option_type(Account_$reflection())], ["ContentSizeBytes", int32_type]]);
}

export function UploadModule_findContentSizeBytes(documentContent) {
    const bytes = urlDataBytes(documentContent);
    return bytes.length | 0;
}

/**
 * Reads a documents contents and returns its size as a formatted string like: 105.65MB or 1.25GB
 */
export function UploadModule_formatDocumentSize(bytes) {
    const kb = bytes / 1000;
    if (kb <= 1) {
        return toText(printf("%iB"))(bytes);
    }
    else {
        const mb = kb / 1000;
        if (mb <= 1) {
            return toText(printf("%0.2fkB"))(kb);
        }
        else {
            const gb = mb / 1000;
            if (gb <= 1) {
                return toText(printf("%0.2fMB"))(mb);
            }
            else {
                return toText(printf("%0.2fGB"))(gb);
            }
        }
    }
}

/**
 * Reads a list of uploaded files and turns them into document upload forms async
 */
export function UploadModule_readFiles(treeId, callback, files) {
    let pr_2;
    let pr_1;
    const pr = map((file) => (new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = ((ev) => {
            let bind$0040;
            console.debug("File reader on load:", ev, file);
            const content = reader.result;
            const lastModified = toString(new Date(file.lastModified), "yyyy-MM-dd");
            resolve(new Form(newGuid(), false, (bind$0040 = DocumentForm_get_Empty(), new DocumentForm(file.name, file.name, content, treeId, bind$0040.TypeId, bind$0040.Number, bind$0040.Version, bind$0040.IsHidden, file.size, lastModified))));
        });
        reader.onerror = ((ev_1) => {
            console.error(some("Error reading document"), ev_1);
            reject(new Error("Failed reading document"));
        });
        reader.readAsDataURL(file);
    })), files);
    pr_1 = (Promise.all(pr));
    pr_2 = (pr_1.then((arg) => {
        callback(new FSharpResult$2(0, [arg]));
    }));
    pr_2.then(void 0, ((ex) => {
        callback(new FSharpResult$2(1, [ex]));
    }));
}

function UploadModule_DocumentFormRow(uploadModule_DocumentFormRowInputProps) {
    let elements, elems_2, elems_1, elems, elems_4;
    const onChange = uploadModule_DocumentFormRowInputProps.onChange;
    const form = uploadModule_DocumentFormRowInputProps.form;
    const key = uploadModule_DocumentFormRowInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(true);
    const patternInput_1 = reactApi.useState(true);
    const setValidNumber = patternInput_1[1];
    let isAdmin;
    const matchValue = ctx.Session;
    if (matchValue != null) {
        const s = matchValue;
        isAdmin = (s.IsSuperAdmin ? true : s.IsAdmin);
    }
    else {
        isAdmin = false;
    }
    return MuiHelpers_createElement(Paper, [["key", toString_1(key)], ["style", {
        padding: 15 + "px",
        display: "flex",
        flexDirection: "column",
        rowGap: 10 + "px",
    }], ["variant", "elevation"], (elements = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
    }], (elems_2 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        columnGap: 10 + "px",
        width: 100 + "%",
    }], (elems_1 = [MuiHelpers_createElement(TextField, [["id", `document-number-input-${key}`], ["style", {
        minWidth: 10 + "ch",
    }], ["variant", "outlined"], ["fullWidth", false], ["label", ctx.Locale.t("Document.DocumentNoShort")], ["defaultValue", form.Document.Number], ["onChange", (e) => {
        let bind$0040, bind$0040_1;
        const x = e.target.value;
        try {
            if (x === "") {
                onChange(new Form(form.TmpId, form.Scanned, (bind$0040 = form.Document, new DocumentForm(bind$0040.Title, bind$0040.Filename, bind$0040.Content, bind$0040.CategoryTreeId, bind$0040.TypeId, undefined, bind$0040.Version, bind$0040.IsHidden, bind$0040.ContentSizeBytes, bind$0040.Date))));
                setValidNumber(true);
            }
            else {
                const asInt = parse(x, 511, false, 32) | 0;
                if (asInt >= 0) {
                    onChange(new Form(form.TmpId, form.Scanned, (bind$0040_1 = form.Document, new DocumentForm(bind$0040_1.Title, bind$0040_1.Filename, bind$0040_1.Content, bind$0040_1.CategoryTreeId, bind$0040_1.TypeId, asInt, bind$0040_1.Version, bind$0040_1.IsHidden, bind$0040_1.ContentSizeBytes, bind$0040_1.Date))));
                    setValidNumber(true);
                }
                else {
                    setValidNumber(false);
                }
            }
        }
        catch (matchValue_1) {
            setValidNumber(false);
        }
    }], ["error", !patternInput_1[0]]]), createElement("div", createObj(ofArray([["style", {
        width: 100 + "%",
    }], (elems = [MuiHelpers_createElement(TextField, toList(delay(() => append(singleton(["id", `document-title-input-${key}`]), delay(() => append(singleton(["style", {
        flexGrow: 1,
        marginBottom: 10,
    }]), delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["required", true]), delay(() => append(singleton(["fullWidth", true]), delay(() => append(singleton(["label", ctx.Locale.t("Document.Name")]), delay(() => append(singleton(["defaultValue", form.Document.Title]), delay(() => append(singleton(["onChange", (e_1) => {
        let bind$0040_2;
        const x_1 = e_1.target.value;
        onChange(new Form(form.TmpId, form.Scanned, (bind$0040_2 = form.Document, new DocumentForm(x_1, bind$0040_2.Filename, bind$0040_2.Content, bind$0040_2.CategoryTreeId, bind$0040_2.TypeId, bind$0040_2.Number, bind$0040_2.Version, bind$0040_2.IsHidden, bind$0040_2.ContentSizeBytes, bind$0040_2.Date))));
        patternInput[1](x_1.length > 0);
    }]), delay(() => (!patternInput[0] ? singleton(["error", true]) : empty())))))))))))))))))))), MuiHelpers_createElement(Typography, [["variant", "body2"], ["children", form.Document.Filename]])], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "row",
        flexWrap: "wrap",
        justifyContent: "start",
        alignItems: "center",
        columnGap: 20 + "px",
        margin: 5 + "px",
    }], (elems_4 = toList(delay(() => {
        let elems_3;
        return append(singleton(createElement("div", createObj(ofArray([["style", {}], (elems_3 = [MuiHelpers_createElement(TextField, [["id", `doc-date-${key}`], ["type", "date"], ["value", form.Document.Date], ["size", "small"], ["variant", "outlined"], ["label", ctx.Locale.t("Date")], ["onChange", (e_2) => {
            let bind$0040_3;
            const x_2 = e_2.target.value;
            try {
                onChange(new Form(form.TmpId, form.Scanned, (bind$0040_3 = form.Document, new DocumentForm(bind$0040_3.Title, bind$0040_3.Filename, bind$0040_3.Content, bind$0040_3.CategoryTreeId, bind$0040_3.TypeId, bind$0040_3.Number, bind$0040_3.Version, bind$0040_3.IsHidden, bind$0040_3.ContentSizeBytes, toString(parse_1(x_2), "yyyy-MM-dd")))));
            }
            catch (matchValue_2) {
            }
        }]])], ["children", reactApi.Children.toArray(Array.from(elems_3))])])))), delay(() => (isAdmin ? singleton(MuiHelpers_createElement(FormControlLabel, [["labelPlacement", "end"], ["label", ctx.Locale.t("Document.Hide")], ["control", MuiHelpers_createElement(Checkbox, [["checked", form.Document.IsHidden], ["onChange", (e_3) => {
            let bind$0040_4;
            onChange(new Form(form.TmpId, form.Scanned, (bind$0040_4 = form.Document, new DocumentForm(bind$0040_4.Title, bind$0040_4.Filename, bind$0040_4.Content, bind$0040_4.CategoryTreeId, bind$0040_4.TypeId, bind$0040_4.Number, bind$0040_4.Version, e_3.target.checked, bind$0040_4.ContentSizeBytes, bind$0040_4.Date))));
        }], ["color", "primary"], ["id", "checkbox-is-hidden"]])]])) : empty())));
    })), ["children", reactApi.Children.toArray(Array.from(elems_4))])])))], ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

/**
 * Component used for uploading documents to a given target (Machine or Customer), with optional document-tree placement
 */
export function UploadModule_UploadForm(uploadModule_UploadFormInputProps) {
    let elements_3, tree_2, folderName, elements_1, children_4;
    const onClose = uploadModule_UploadFormInputProps.onClose;
    const files = uploadModule_UploadFormInputProps.files;
    const customerAttachment = uploadModule_UploadFormInputProps.customerAttachment;
    const tree = uploadModule_UploadFormInputProps.tree;
    const customerId = uploadModule_UploadFormInputProps.customerId;
    const target = uploadModule_UploadFormInputProps.target;
    const ctx = reactApi.useContext(ctx_1);
    const patternInput = reactApi.useState(false);
    const setLoadingFiles = patternInput[1];
    const patternInput_1 = reactApi.useState([]);
    const updateForm = patternInput_1[1];
    const forms = patternInput_1[0];
    const patternInput_2 = reactApi.useState([]);
    const newDocuments = patternInput_2[0];
    const patternInput_3 = reactApi.useState([]);
    const virus = patternInput_3[0];
    const patternInput_4 = reactApi.useState(undefined);
    const setErrorMsg = patternInput_4[1];
    const errorMsg = patternInput_4[0];
    const patternInput_5 = reactApi.useState(false);
    const patternInput_6 = reactApi.useState(false);
    const setProcessing = patternInput_6[1];
    const patternInput_7 = reactApi.useState(false);
    const uploaded = patternInput_7[0];
    const setUploaded = patternInput_7[1];
    const fileInputRef = reactApi.useRef(undefined);
    const handleClose = () => {
        onClose(newDocuments);
    };
    const onFilesRead = (filesRes) => {
        console.debug("Read files", files);
        setLoadingFiles(false);
        patternInput_5[1](true);
        if (filesRes.tag === 0) {
            updateForm(map_1((form) => {
                let bind$0040;
                return new Form(form.TmpId, form.Scanned, (bind$0040 = form.Document, new DocumentForm(bind$0040.Title, bind$0040.Filename, bind$0040.Content, bind$0040.CategoryTreeId, bind$0040.TypeId, bind$0040.Number, bind$0040.Version, defaultArg(map_2((category) => category.PtgOnly, tree), false), bind$0040.ContentSizeBytes, bind$0040.Date)));
            }, filesRes.fields[0]));
        }
        else {
            setErrorMsg("Kunne ikke lese fil(ene)");
        }
    };
    useEffectOnce(() => {
        if (files.length !== 0) {
            const treeId = map_2((tree_1) => tree_1.Id, tree);
            console.debug("Opened upload form with files");
            UploadModule_readFiles(treeId, onFilesRead, files);
        }
    });
    return MuiHelpers_createElement(Dialog, [["maxWidth", "md"], ["open", true], ["onClose", (_arg_3, v) => {
        onClose([]);
    }], ["PaperProps", {
        style: {
            width: 100 + "%",
            maxWidth: 800,
        },
    }], (elements_3 = [MuiHelpers_createElement(DialogTitle, [["children", (tree != null) ? ((tree_2 = tree, (folderName = ((ctx.Language.tag === 1) ? tree_2.NameEN : tree_2.NameNO), ctx.Locale.t("Document.UploadTo", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["folderName", folderName]))))) : ctx.Locale.t("Document.Upload")]]), MuiHelpers_createElement(DialogContent, [["dividers", true], (elements_1 = toList(delay(() => append(singleton(errorBanner(errorMsg, () => {
        setErrorMsg(undefined);
    })), delay(() => {
        let elems_2;
        return append(singleton(createElement("div", createObj(ofArray([["style", {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            flexDirection: "column",
            border: ((((1 + "px") + " ") + "solid") + " ") + "black",
            padding: 10 + "px",
            margin: 10 + "px",
        }], (elems_2 = toList(delay(() => {
            let elems;
            return append(singleton(createElement("label", createObj(ofArray([["style", {
                cursor: "pointer",
                textAlign: "center",
                marginBottom: 5,
            }], (elems = [MuiHelpers_createElement(Typography, [["style", {
                textDecorationLine: "underline",
            }], ["children", !patternInput_5[0] ? ctx.Locale.t("Document.ChooseFile") : ctx.Locale.t("Document.ChooseOtherFile")]]), createElement("input", {
                style: {
                    display: "none",
                },
                type: "file",
                ref: fileInputRef,
                multiple: true,
                onChange: (ev) => {
                    const fileList_1 = ev.target.files;
                    if (!(fileList_1 == null)) {
                        const fileList = toList(delay(() => map((i) => fileList_1.item(i), rangeDouble(0, 1, fileList_1.length - 1))));
                        setUploaded(false);
                        setErrorMsg(undefined);
                        try {
                            const treeId_1 = map_2((tree_3) => tree_3.Id, tree);
                            const files_2 = toArray(fileList);
                            console.debug("File input", files_2);
                            setLoadingFiles(true);
                            UploadModule_readFiles(treeId_1, onFilesRead, files_2);
                        }
                        catch (e) {
                            console.error(some("Error reading files for upload"), e.message);
                        }
                    }
                },
            })], ["children", reactApi.Children.toArray(Array.from(elems))])])))), delay(() => (patternInput[0] ? singleton(loadingIndicator()) : ((forms.length === 0) ? singleton(createElement("span", {
                style: {
                    fontSize: 0.8 + "rem",
                    marginBottom: 10,
                },
                children: ctx.Locale.t("Document.NoFileSelected"),
            })) : singleton(createElement("span", {
                style: {
                    marginBottom: 10,
                    fontStyle: "italic",
                    fontSize: 0.8 + "rem",
                },
                children: reactApi.Children.toArray([]),
            }))))));
        })), ["children", reactApi.Children.toArray(Array.from(elems_2))])])))), delay(() => {
            let props_8;
            return append((virus.length > 0) ? singleton(MuiHelpers_createElement(Alert, [["severity", "error"], ["icon", (props_8 = {}, react.createElement(Error$, props_8))], ["children", ctx.Locale.t("Document.VirusFound")]])) : empty(), delay(() => {
                let elems_5;
                return singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    gap: 20 + "px",
                    padding: 20 + "px",
                }], (elems_5 = (!uploaded ? map_1((form_3) => {
                    const $keyZ28D10DDE = form_3.TmpId;
                    return createElement(UploadModule_DocumentFormRow, {
                        key: $keyZ28D10DDE,
                        $key: $keyZ28D10DDE,
                        form: form_3,
                        onChange: (updatedForm) => {
                            updateForm(map_1((oldForm) => {
                                if (oldForm.TmpId === updatedForm.TmpId) {
                                    return updatedForm;
                                }
                                else {
                                    return oldForm;
                                }
                            }, forms));
                        },
                    });
                }, forms) : ((virus.length > 0) ? map_1((scan) => {
                    let props_11, elements, elems_3, props_17;
                    if (scan.Virus) {
                        return MuiHelpers_createElement(Alert, [["icon", (props_11 = {}, react.createElement(Warning, props_11))], ["severity", "error"], (elements = [createElement("div", createObj(singleton_1((elems_3 = [createElement("span", {
                            children: [`Virus: ${scan.Filename}`],
                        })], ["children", reactApi.Children.toArray(Array.from(elems_3))])))), createElement("span", {
                            style: {
                                whiteSpace: "pre",
                            },
                            children: scan.Description,
                        })], ["children", reactApi.Children.toArray(Array.from(elements))])]);
                    }
                    else {
                        return MuiHelpers_createElement(Alert, [["icon", (props_17 = {}, react.createElement(Check, props_17))], ["severity", "warning"], ["children", `${ctx.Locale.t("Document.NoVirus")} ${scan.Filename}`]]);
                    }
                }, virus) : map_1((doc) => {
                    let props_20;
                    return MuiHelpers_createElement(Alert, [["icon", (props_20 = {}, react.createElement(Check, props_20))], ["severity", "success"], ["children", `${ctx.Locale.t("Uploaded")} ${doc.Filename}`]]);
                }, newDocuments))), ["children", reactApi.Children.toArray(Array.from(elems_5))])]))));
            }));
        }));
    })))), ["children", reactApi.Children.toArray(Array.from(elements_1))])]), (children_4 = toList(delay(() => (patternInput_6[0] ? singleton(loadingIndicatorSmall()) : append(singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["children", ctx.Locale.t("Cancel")], ["onClick", (_arg_5) => {
        onClose([]);
    }]])), delay(() => {
        let elems_7, elems_8;
        return singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["disabled", (forms.length === 0) ? true : forms.some((form_4) => {
            if (isNullOrWhiteSpace(form_4.Document.Title)) {
                return true;
            }
            else {
                return form_4.Document.Content.length === 0;
            }
        })], ["startIcon", uploaded ? createElement("div", createObj(ofArray([["style", {
            color: "#FFFFFF",
        }], (elems_7 = toList(delay(() => {
            if ((errorMsg == null) && (virus.length === 0)) {
                return singleton(createElement(Components_TimedProgress_ZB2B7FD7, {
                    onEnd: () => {
                        handleClose();
                    },
                    closeTimeMs: 1500,
                }));
            }
            else if (virus.length > 0) {
                console.warn(some("We found suspicious files in your upload! Signing you out."));
                return singleton(createElement(Components_TimedProgress_ZB2B7FD7, {
                    onEnd: () => {
                        RouterModule_nav(singleton_1("signout"), 1, 1);
                    },
                    closeTimeMs: 4000,
                }));
            }
            else {
                return singleton(defaultOf_1());
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_7))])]))) : defaultOf_1()], ["onClick", (_arg_6) => {
            let properties_2;
            if (uploaded) {
                handleClose();
            }
            else {
                const url = customerAttachment ? ("/api/document" + generateQueryString([["customer-attachment", toString_1(true)]])) : "/api/document";
                const documents = map_1((form_1) => form_1.Document, forms);
                const form_2 = new DocumentUploadForm((target.tag === 1) ? target.fields[0] : target.fields[0], customerId, (target.tag === 1) ? undefined : target.fields[0], Documents_DocumentSource__get_Id(new Documents_DocumentSource(2, [])), documents);
                setProcessing(true);
                let pr_2;
                let pr_1;
                const body = Auto_generateBoxedEncoder_437914C6(DocumentUploadForm_$reflection(), undefined, undefined, undefined)(form_2);
                const decoder = Auto_generateBoxedDecoder_Z6670B51(DocumentScanResult_$reflection(), undefined, undefined);
                const data_1 = some(body);
                const caseStrategy_3 = undefined;
                const extra_3 = undefined;
                try {
                    const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["POST"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_2((data_1_1) => cons(new Types_RequestProperties(2, [toString_2(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                        let response_1, decoder_1_1;
                        return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(DocumentScanResult_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                            let matchValue;
                            return Promise.resolve((matchValue = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue.fields[0]])])) : (new FSharpResult$2(0, [matchValue.fields[0]]))));
                        })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                    }))));
                    pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
                }
                catch (exn) {
                    pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                }
                pr_2 = (pr_1.then((res) => mapFetchError((statusCode) => {
                    let maxUploadDocumentCount, maxUploadDocumentSize;
                    switch (statusCode) {
                        case 401:
                            return ctx.Locale.t("Document.MissingPermission");
                        case 413:
                            return (maxUploadDocumentCount = int32ToString(Documents_maxUploadDocumentCount), (maxUploadDocumentSize = int32ToString(~~(Documents_maxUploadSizeKB / 1000)), ctx.Locale.t("Document.DocumentsTooLarge", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})((((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["maxUploadDocumentCount", maxUploadDocumentCount])),["maxUploadDocumentSize", maxUploadDocumentSize]))));
                        default:
                            return ctx.Locale.t("Document.UploadFailed");
                    }
                }, res)));
                pr_2.then((scanResults) => {
                    if (scanResults.tag === 1) {
                        const err_1 = scanResults.fields[0];
                        console.error(some("Failed scanning documents"), err_1);
                        if (fileInputRef.current != null) {
                            const input = value_314(fileInputRef.current);
                            input.value = "";
                        }
                        setErrorMsg(err_1);
                    }
                    else if (scanResults.fields[0].tag === 0) {
                        patternInput_3[1](scanResults.fields[0].fields[0]);
                    }
                    else {
                        patternInput_2[1](scanResults.fields[0].fields[0]);
                    }
                    setUploaded(true);
                    setProcessing(false);
                });
            }
        }], (elems_8 = toList(delay(() => (uploaded ? singleton(createElement("span", {
            style: {},
            children: ctx.Locale.t("Close"),
        })) : singleton(ctx.Locale.t("Document.Upload"))))), ["children", reactApi.Children.toArray(Array.from(elems_8))])]));
    }))))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_4))]]))], ["children", reactApi.Children.toArray(Array.from(elements_3))])]);
}

export function UploadModule_docToRevisionForm(document$) {
    return new DocumentRevisionForm(document$.Guid, document$.Number, document$.Version, document$.Title, document$.Filename, "", 0, document$.Date, document$.IsHidden, document$.CategoryTreeId, document$.ManuallyMoved, "");
}

export function Upload_MetaCard_1574F38B(upload_MetaCard_1574F38BInputProps) {
    let elements;
    const document$ = upload_MetaCard_1574F38BInputProps.document;
    const form = upload_MetaCard_1574F38BInputProps.form;
    const meta = upload_MetaCard_1574F38BInputProps.meta;
    const ctx = reactApi.useContext(ctx_1);
    const notSynced = !equals(Documents_DocumentSource_FromId_Z524259A4(document$.SourceId), new Documents_DocumentSource(2, [])) && (document$.ContentId == null);
    let highestVersion;
    const value = (notSynced ? 0 : 1) | 0;
    highestVersion = defaultArg(tryHead(sortDescending(map_1((ver) => ver.Version, document$.Versions, Int32Array), {
        Compare: comparePrimitives,
    })), value);
    const uploader = getDocumentUploader(meta.Uploader);
    const rowDiv = (label, value_1) => createElement("div", {
        style: {
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
        },
        children: reactApi.Children.toArray([label, value_1]),
    });
    return MuiHelpers_createElement(Paper, [["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => append((notSynced && isNullOrWhiteSpace(form.Content)) ? singleton(["justifyContent", "flex-start"]) : singleton(["justifyContent", "space-evenly"]), delay(() => append(singleton(["flexGrow", 1]), delay(() => append(singleton(["rowGap", 5 + "px"]), delay(() => singleton(["padding", 10 + "px"]))))))))))))))], (elements = toList(delay(() => ((notSynced && isNullOrWhiteSpace(form.Content)) ? singleton(MuiHelpers_createElement(Alert, [["severity", "warning"], ["children", "Not synced"]])) : append(!isNullOrWhiteSpace(form.Content) ? singleton(MuiHelpers_createElement(Alert, [["variant", "outlined"], ["severity", "success"], ["children", "Nytt dokument"]])) : empty(), delay(() => append(singleton(rowDiv(createElement("b", {
        children: ["Filnavn"],
    }), createElement("span", {
        className: join(" ", ["text-overflow"]),
        style: {
            display: "inline-block",
            maxWidth: 40 + "ch",
        },
        title: form.Filename,
        children: form.Filename,
    }))), delay(() => {
        let elems_1;
        return append(singleton(rowDiv(createElement("b", {
            children: ["Versjon"],
        }), createElement("div", createObj(ofArray([["style", {
            display: "flex",
            alignItems: "center",
        }], (elems_1 = toList(delay(() => append(singleton(createElement("span", {
            style: {
                textAlign: "right",
            },
            children: `${form.Version}`,
        })), delay(() => {
            let props_8;
            return append((form.Version !== form.Version) ? append(singleton((props_8 = {
                fontSize: "small",
            }, react.createElement(ArrowRightAlt, props_8))), delay(() => singleton(createElement("span", {
                style: {},
                children: `${form.Version}`,
            })))) : empty(), delay(() => {
                let props_11;
                return (form.Version < highestVersion) ? singleton(wrapTooltip("Dokumentet er satt til en eldre versjon. Se under versjoner for å finne den nyeste", MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_11 = {}, react.createElement(PriorityHigh, props_11))]]))) : empty();
            }));
        })))), ["children", reactApi.Children.toArray(Array.from(elems_1))])]))))), delay(() => {
            let elems_2;
            return append(singleton(rowDiv(createElement("b", {
                children: ["Filstørrelse"],
            }), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                alignItems: "center",
                justifyContent: "right",
            }], (elems_2 = toList(delay(() => append(singleton(createElement("span", {
                children: `${UploadModule_formatDocumentSize(meta.ContentSizeBytes)}`,
            })), delay(() => {
                let props_17;
                return ((form.ContentSizeBytes > 0) && !isNullOrWhiteSpace(form.Content)) ? append(singleton((props_17 = {}, react.createElement(ArrowRightAlt, props_17))), delay(() => singleton(createElement("span", {
                    children: [UploadModule_formatDocumentSize(form.ContentSizeBytes)],
                })))) : empty();
            })))), ["children", reactApi.Children.toArray(Array.from(elems_2))])]))))), delay(() => append(singleton(rowDiv(createElement("b", {
                children: ["Opplaster"],
            }), createElement("span", {
                children: [uploader],
            }))), delay(() => singleton(rowDiv(createElement("b", {
                children: ["Lastet opp"],
            }), createElement("span", {
                children: [toDateAndTimeStr(ctx.DateFnsLocale, meta.Uploaded)],
            })))))));
        }));
    }))))))), ["children", reactApi.Children.toArray(Array.from(elements))])]);
}

export function Upload_EditForm_Z6F414B8D(upload_EditForm_Z6F414B8DInputProps) {
    let elems_1, elems, elements_5, elements, elements_4, elems_3, elements_3, elements_10, elements_8, children_9;
    const customerAttachment = upload_EditForm_Z6F414B8DInputProps.customerAttachment;
    const machineId = upload_EditForm_Z6F414B8DInputProps.machineId;
    const treeId = upload_EditForm_Z6F414B8DInputProps.treeId;
    const document$ = upload_EditForm_Z6F414B8DInputProps.document;
    const onClose = upload_EditForm_Z6F414B8DInputProps.onClose;
    const customerId = upload_EditForm_Z6F414B8DInputProps.customerId;
    const isOpen = upload_EditForm_Z6F414B8DInputProps.isOpen;
    const key = upload_EditForm_Z6F414B8DInputProps.$key;
    const ctx = reactApi.useContext(ctx_1);
    const customerAttachment_1 = defaultArg(customerAttachment, false);
    const patternInput = reactApi.useState(false);
    const setProcessing = patternInput[1];
    const processing = patternInput[0];
    const patternInput_1 = reactApi.useState(false);
    const uploaded = patternInput_1[0];
    const setUploaded = patternInput_1[1];
    const patternInput_2 = reactApi.useState(false);
    const updated = patternInput_2[0];
    const setUpdated = patternInput_2[1];
    const patternInput_3 = reactApi.useState(false);
    const versionsOpen = patternInput_3[0];
    const setVersionsOpen = patternInput_3[1];
    const updatedDocRef = reactApi.useRef(undefined);
    const patternInput_4 = reactApi.useState([]);
    const virus = patternInput_4[0];
    const setVirus = patternInput_4[1];
    let patternInput_5;
    const initial_5 = UploadModule_docToRevisionForm(document$);
    patternInput_5 = reactApi.useState(initial_5);
    const setForm = patternInput_5[1];
    const form = patternInput_5[0];
    let patternInput_6;
    const initial_6 = new FormMeta(document$.Uploaded, document$.Uploader, document$.ContentSizeBytes);
    patternInput_6 = reactApi.useState(initial_6);
    const setMeta = patternInput_6[1];
    const titleRef = reactApi.useRef(undefined);
    const filelistRef = reactApi.useRef(undefined);
    const changeReasonRef = reactApi.useRef(undefined);
    const patternInput_7 = reactApi.useState(undefined);
    const setErrorMsg = patternInput_7[1];
    const errorMsg = patternInput_7[0];
    const patternInput_8 = reactApi.useState(undefined);
    const changeReasonError = patternInput_8[0];
    const notSynced = !equals(Documents_DocumentSource_FromId_Z524259A4(document$.SourceId), new Documents_DocumentSource(2, [])) && (document$.ContentId == null);
    if ((((((((form.Title === document$.Title) && (form.IsHidden === document$.IsHidden)) && equals(form.RevisionDate, document$.Date)) && equals(form.CategoryTreeId, document$.CategoryTreeId)) && (form.Version === document$.Version)) && (form.Filename === document$.Filename)) && (form.ManuallyMoved === document$.ManuallyMoved)) && updated) {
        console.debug("No changes!");
        setUpdated(false);
    }
    let patternInput_9;
    const matchValue = ctx.Session;
    if (matchValue != null) {
        const s = matchValue;
        patternInput_9 = [s.IsPtg, s.IsAdmin ? true : s.IsSuperAdmin];
    }
    else {
        patternInput_9 = [false, false];
    }
    let highestVersion;
    const value = (notSynced ? 0 : 1) | 0;
    highestVersion = defaultArg(tryHead(sortDescending(map_1((ver) => ver.Version, document$.Versions, Int32Array), {
        Compare: comparePrimitives,
    })), value);
    const handleClose = () => {
        console.debug("Closing form with updated doc being", updatedDocRef.current);
        onClose(updatedDocRef.current);
        updatedDocRef.current = undefined;
        setErrorMsg(undefined);
        setVirus([]);
        setProcessing(false);
        setVersionsOpen(false);
        setUpdated(false);
    };
    const dependencies = [isOpen];
    reactApi.useEffect(() => {
        if (isOpen) {
            console.debug("[DocumentUpload] Edit form Opened");
            setUploaded(false);
        }
    }, dependencies);
    const uploadSection = createElement("div", createObj(ofArray([["style", {
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        border: ((((1 + "px") + " ") + "solid") + " ") + "black",
        padding: 10 + "px",
    }], (elems_1 = [createElement("label", createObj(ofArray([["style", {
        cursor: "pointer",
        textAlign: "center",
        marginBottom: 5,
    }], (elems = [MuiHelpers_createElement(Typography, [["style", {
        textDecorationLine: "underline",
    }], ["children", ctx.Locale.t("Document.ChooseFile")]]), createElement("input", {
        style: {
            display: "none",
        },
        type: "file",
        ref: filelistRef,
        multiple: true,
        onChange: (ev) => {
            const fileList_1 = ev.target.files;
            if (!(fileList_1 == null)) {
                const fileList = toList(delay(() => map((i) => fileList_1.item(i), rangeDouble(0, 1, fileList_1.length - 1))));
                setErrorMsg(undefined);
                try {
                    console.debug("File input", fileList);
                    UploadModule_readFiles(treeId, (filesRes) => {
                        if (filesRes.tag === 0) {
                            const newFile = head(filesRes.fields[0]);
                            const newVersion_1 = ((document$.Versions.length <= 0) ? (notSynced ? 1 : 2) : (maxBy((doc_1) => doc_1.Version, document$.Versions, {
                                Compare: comparePrimitives,
                            }).Version + 1)) | 0;
                            iterate((input_1) => {
                                input_1.value = newFile.Document.Title;
                            }, toArray_1(titleRef.current));
                            setForm(new DocumentRevisionForm(form.DocumentId, form.DocumentNumber, newVersion_1, newFile.Document.Title, newFile.Document.Filename, newFile.Document.Content, newFile.Document.ContentSizeBytes, newFile.Document.Date, form.IsHidden, form.CategoryTreeId, form.ManuallyMoved, form.ChangeReason));
                            setUpdated(true);
                        }
                        else {
                            setErrorMsg("Kunne ikke lese fil(ene)");
                        }
                    }, fileList);
                }
                catch (e) {
                    console.error(some("Error reading files for upload"), e.message);
                }
            }
        },
    })], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi.Children.toArray(Array.from(elems_1))])])));
    const docNumInput = MuiHelpers_createElement(TextField, [["id", `document-number-input-${key}`], ["style", {
        minWidth: 10 + "ch",
    }], ["variant", "outlined"], ["fullWidth", false], ["label", ctx.Locale.t("Document.DocumentNoShort")], ["disabled", document$.IsDeleted], ["defaultValue", document$.Number], ["onChange", (e_1) => {
        const numStr = e_1.target.value;
        console.debug("Updated doc num", numStr);
    }]]);
    const titleInput = MuiHelpers_createElement(TextField, toList(delay(() => append(singleton(["id", `document-title-input-${form.DocumentId}`]), delay(() => append(singleton(["style", {
        flexGrow: 1,
        marginBottom: 10,
    }]), delay(() => append(singleton(["onBlur", (ev_1) => {
        const target = ev_1.target;
        console.debug("target value", target.value);
        const newTitle = target.value;
        setUpdated(true);
        setForm(new DocumentRevisionForm(form.DocumentId, form.DocumentNumber, form.Version, newTitle, form.Filename, form.Content, form.ContentSizeBytes, form.RevisionDate, form.IsHidden, form.CategoryTreeId, form.ManuallyMoved, form.ChangeReason));
    }]), delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["label", "Tittel"]), delay(() => append(singleton(["required", true]), delay(() => append(singleton(["fullWidth", true]), delay(() => append(singleton(["disabled", document$.IsDeleted]), delay(() => append(singleton(["inputRef", titleRef]), delay(() => append(singleton(["defaultValue", form.Title]), delay(() => (isNullOrWhiteSpace(form.Title) ? singleton(["error", true]) : empty()))))))))))))))))))))))));
    const documentDateInput = MuiHelpers_createElement(TextField, [["size", "small"], ["variant", "outlined"], ["id", `doc-date-${form.DocumentId}`], ["type", "date"], ["fullWidth", true], ["disabled", document$.IsDeleted], ["label", ctx.Locale.t("Date")], ["value", defaultArg(form.RevisionDate, defaultOf())], ["onChange", (e_2) => {
        const newDateStr_1 = e_2.target.value;
        const dateRes = tryWith(parse_2, newDateStr_1);
        if (dateRes.tag === 1) {
            console.error(some("Failed parsing date"), dateRes.fields[0]);
        }
        else {
            const newDateStr = newDateStr_1;
            console.debug("New date", newDateStr);
            setUpdated(true);
            setForm(new DocumentRevisionForm(form.DocumentId, form.DocumentNumber, form.Version, form.Title, form.Filename, form.Content, form.ContentSizeBytes, newDateStr, form.IsHidden, form.CategoryTreeId, form.ManuallyMoved, form.ChangeReason));
        }
    }]]);
    const versionsList = MuiHelpers_createElement(List, [(elements_5 = [condDisabledTooltip("Ingen versjoner", document$.Versions.length === 0, MuiHelpers_createElement(ListItem, [["onClick", (_arg_2) => {
        setVersionsOpen(!versionsOpen);
    }], ["button", true], ["disabled", document$.Versions.length === 0], (elements = toList(delay(() => append(singleton(MuiHelpers_createElement(ListItemText, [["primary", "Tidligere versjoner"]])), delay(() => {
        let props_8, props_10;
        return versionsOpen ? singleton((props_8 = {}, react.createElement(ExpandLess, props_8))) : singleton((props_10 = {}, react.createElement(ExpandMore, props_10)));
    })))), ["children", reactApi.Children.toArray(Array.from(elements))])])), MuiHelpers_createElement(Collapse, [["in", versionsOpen], (elements_4 = [createElement("div", createObj(ofArray([["style", {
        marginLeft: 20 + "px",
        marginRight: 20 + "px",
    }], (elems_3 = [MuiHelpers_createElement(Typography, [["variant", "body2"], ["children", "Klikk på en versjon for å opprette den gamle versjonen"]])], ["children", reactApi.Children.toArray(Array.from(elems_3))])]))), MuiHelpers_createElement(List, [["dense", true], ["disablePadding", true], ["component", "div"], (elements_3 = map_1((docVer) => {
        let elements_2, elems_4, uploader, elements_1;
        const uploadedStr = toDateAndTimeStr(ctx.DateFnsLocale, docVer.Uploaded);
        const downloadUrl = API_Document_DownloadVersion(docVer.Version, parse_3(document$.Guid));
        return MuiHelpers_createElement(ListItem, [["key", docVer.Version], ["style", {
            paddingLeft: 32 + "px",
        }], ["onClick", (_ev) => {
            console.debug("Clicked on version:", docVer.Version, docVer.Filename);
            const newVersion = docVer.Version | 0;
            const ver_1 = (((form.Version !== highestVersion) && (newVersion === form.Version)) ? highestVersion : newVersion) | 0;
            const docVersion = find((doc) => (doc.Version === ver_1), document$.Versions);
            setUpdated(true);
            setForm(new DocumentRevisionForm(form.DocumentId, form.DocumentNumber, docVersion.Version, form.Title, docVersion.Filename, form.Content, form.ContentSizeBytes, form.RevisionDate, form.IsHidden, form.CategoryTreeId, form.ManuallyMoved, form.ChangeReason));
            setMeta(new FormMeta(docVersion.Uploaded, docVersion.Uploader, docVersion.ContentSizeBytes));
        }], ["button", true], ["divider", true], ["dense", true], (elements_2 = [createElement("div", createObj(ofArray([["style", {
            paddingRight: 20 + "px",
        }], (elems_4 = [MuiHelpers_createElement(Typography, [["variant", "h6"], ["children", docVer.Version]])], ["children", reactApi.Children.toArray(Array.from(elems_4))])]))), MuiHelpers_createElement(ListItemText, [["primary", [MuiHelpers_createElement(Link, [["key", `document-version-link-${docVer.Version}`], ["href", downloadUrl], ["onClick", (ev_2) => {
            ev_2.stopPropagation();
            console.debug("Link click");
        }], ["children", docVer.Filename]])]], ["secondary", (docVer.Uploader == null) ? toText(printf("Lastet opp %s"))(uploadedStr) : ((uploader = value_314(docVer.Uploader), toText(printf("Lastet opp %s av %s"))(uploadedStr)(uploader.Email)))]]), MuiHelpers_createElement(ListItemSecondaryAction, [(elements_1 = [MuiHelpers_createElement(Checkbox, [["color", "primary"], ["checked", docVer.Version === form.Version]])], ["children", reactApi.Children.toArray(Array.from(elements_1))])])], ["children", reactApi.Children.toArray(Array.from(elements_2))])]);
    }, sortByDescending((version) => version.Version, document$.Versions, {
        Compare: comparePrimitives,
    })), ["children", reactApi.Children.toArray(Array.from(elements_3))])])], ["children", reactApi.Children.toArray(Array.from(elements_4))])])], ["children", reactApi.Children.toArray(Array.from(elements_5))])]);
    return MuiHelpers_createElement(Dialog, [["maxWidth", "md"], ["open", isOpen], ["onClose", (_arg_4, v) => {
        handleClose();
    }], ["PaperProps", {
        style: {
            width: 100 + "%",
            maxWidth: 800,
        },
    }], (elements_10 = [MuiHelpers_createElement(DialogTitle, [["children", ctx.Locale.t("Document.Replace")]]), MuiHelpers_createElement(DialogContent, [["style", {
        display: "flex",
        flexDirection: "column",
        rowGap: 15 + "px",
    }], ["dividers", true], (elements_8 = toList(delay(() => append(singleton(errorBanner(errorMsg, () => {
        setErrorMsg(undefined);
    })), delay(() => {
        let props_26;
        return append((virus.length > 0) ? singleton(MuiHelpers_createElement(Alert, [["severity", "error"], ["icon", (props_26 = {}, react.createElement(Error$, props_26))], ["children", ctx.Locale.t("Document.VirusFound")]])) : empty(), delay(() => append(document$.IsDeleted ? singleton(MuiHelpers_createElement(Alert, [["severity", "error"], ["children", toText(printf("Dokumentet er slettet"))]])) : empty(), delay(() => append(singleton(uploadSection), delay(() => {
            let elems_22;
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 20 + "px",
            }], (elems_22 = toList(delay(() => {
                let elems_19, props_50;
                return !uploaded ? singleton(createElement("div", createObj(ofArray([["style", {
                    display: "flex",
                    flexDirection: "column",
                    rowGap: 10 + "px",
                }], (elems_19 = toList(delay(() => {
                    let elems_11;
                    return append(singleton(createElement("div", createObj(ofArray([["style", {
                        display: "flex",
                        flexDirection: "row",
                        columnGap: 10 + "px",
                    }], (elems_11 = [docNumInput, createElement("div", {
                        style: {
                            flexGrow: 1,
                        },
                        children: reactApi.Children.toArray([titleInput]),
                    })], ["children", reactApi.Children.toArray(Array.from(elems_11))])])))), delay(() => {
                        let elems_16, elems_15;
                        return append(singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "row"]), delay(() => append(singleton(["justifyContent", "space-between"]), delay(() => append((notSynced && isNullOrWhiteSpace(form.Content)) ? singleton(["alignItems", "start"]) : empty(), delay(() => singleton(["columnGap", 10 + "px"]))))))))))))], (elems_16 = [createElement(Upload_MetaCard_1574F38B, {
                            meta: patternInput_6[0],
                            form: form,
                            document: document$,
                        }), createElement("div", createObj(ofArray([["style", {
                            display: "flex",
                            flexDirection: "column",
                            gap: 10 + "px",
                            margin: 5 + "px",
                            width: 25 + "ch",
                        }], (elems_15 = toList(delay(() => append(singleton(createElement("div", {
                            style: {},
                            children: reactApi.Children.toArray([documentDateInput]),
                        })), delay(() => {
                            let id_1, elems_13;
                            return append((machineId != null) ? ((id_1 = (value_314(machineId) | 0), singleton(createElement("div", createObj(ofArray([["style", {}], (elems_13 = [createElement(CategorySelection, {
                                machineId: id_1,
                                categoryId: unwrap(form.CategoryTreeId),
                                onChange: (categoryId) => {
                                    setUpdated(true);
                                    setForm(new DocumentRevisionForm(form.DocumentId, form.DocumentNumber, form.Version, form.Title, form.Filename, form.Content, form.ContentSizeBytes, form.RevisionDate, form.IsHidden, categoryId, form.ManuallyMoved, form.ChangeReason));
                                },
                            })], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))))) : empty(), delay(() => {
                                let props_34, props_36;
                                return append((patternInput_9[1] ? true : patternInput_9[0]) ? singleton(MuiHelpers_createElement(Button, [["onClick", (_arg_6) => {
                                    const hidden = !form.IsHidden;
                                    setUpdated(true);
                                    setForm(new DocumentRevisionForm(form.DocumentId, form.DocumentNumber, form.Version, form.Title, form.Filename, form.Content, form.ContentSizeBytes, form.RevisionDate, hidden, form.CategoryTreeId, form.ManuallyMoved, form.ChangeReason));
                                }], ["size", "small"], ["variant", "outlined"], ["fullWidth", true], ["disabled", document$.IsDeleted], ["startIcon", form.IsHidden ? ((props_34 = {
                                    style: {
                                        color: "#FF8C00",
                                    },
                                }, react.createElement(VisibilityOff, props_34))) : ((props_36 = {}, react.createElement(Visibility, props_36)))], ["children", form.IsHidden ? "Vis for kunde" : "Skjul for kunde"]])) : empty(), delay(() => {
                                    let elems_14;
                                    return ((document$.SourceId === Documents_DocumentSource__get_Id(new Documents_DocumentSource(0, []))) && document$.ManuallyMoved) ? singleton(createElement("div", createObj(singleton_1((elems_14 = toList(delay(() => {
                                        let props_39;
                                        return append(singleton(MuiHelpers_createElement(Button, [["onClick", (_arg_7) => {
                                            setForm(new DocumentRevisionForm(form.DocumentId, form.DocumentNumber, form.Version, form.Title, form.Filename, form.Content, form.ContentSizeBytes, form.RevisionDate, form.IsHidden, form.CategoryTreeId, false, form.ChangeReason));
                                            setUpdated(true);
                                        }], ["variant", "outlined"], ["size", "small"], ["fullWidth", true], ["disabled", document$.IsDeleted], ["startIcon", (props_39 = {}, react.createElement(PanTool, props_39))], ["children", "Nullstill flytt"]])), delay(() => (!form.ManuallyMoved ? singleton(MuiHelpers_createElement(Typography, [["variant", "body2"], ["children", "Dokumentet vil nå flyttes tilbake til den originale kategorien den ble syncet til."]])) : empty())));
                                    })), ["children", reactApi.Children.toArray(Array.from(elems_14))]))))) : empty();
                                }));
                            }));
                        })))), ["children", reactApi.Children.toArray(Array.from(elems_15))])])))], ["children", reactApi.Children.toArray(Array.from(elems_16))])])))), delay(() => {
                            let elements_6;
                            return append(singleton(MuiHelpers_createElement(Collapse, [["in", updated], (elements_6 = [MuiHelpers_createElement(TextField, toList(delay(() => append(singleton(["variant", "outlined"]), delay(() => append(singleton(["fullWidth", true]), delay(() => append(singleton(["multiline", true]), delay(() => append(singleton(["label", "Oppgi endringsgrunn"]), delay(() => append(singleton(["inputRef", changeReasonRef]), delay(() => append(singleton(["error", changeReasonError != null]), delay(() => ((changeReasonError != null) ? singleton(["helperText", "Du må oppgi en grunn for å endre dokumentet"]) : empty()))))))))))))))))], ["children", reactApi.Children.toArray(Array.from(elements_6))])])), delay(() => append(!customerAttachment_1 ? singleton(createElement("div", {
                                children: reactApi.Children.toArray([versionsList]),
                            })) : empty(), delay(() => (!customerAttachment_1 ? singleton(createElement(Audits_List_259D9DD2, {
                                documentId: document$.Guid,
                                isOpen: document$.IsDeleted,
                            })) : empty())))));
                        }));
                    }));
                })), ["children", reactApi.Children.toArray(Array.from(elems_19))])])))) : (((errorMsg == null) && (virus.length <= 0)) ? singleton(MuiHelpers_createElement(Alert, [["icon", (props_50 = {}, react.createElement(Check, props_50))], ["severity", "success"], ["children", `${ctx.Locale.t("Document.Uploaded", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})((((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["title", document$.Title])),["filename", document$.Filename]))}`]])) : singleton(map_1((scan) => {
                    let props_53, props_56, elements_7, elems_20;
                    if (!scan.Virus) {
                        return MuiHelpers_createElement(Alert, [["severity", "warning"], ["icon", (props_53 = {}, react.createElement(Check, props_53))], ["children", `${ctx.Locale.t("Document.NoVirus")} ${scan.Filename}`]]);
                    }
                    else {
                        return MuiHelpers_createElement(Alert, [["severity", "error"], ["icon", (props_56 = {}, react.createElement(Warning, props_56))], (elements_7 = [createElement("div", createObj(singleton_1((elems_20 = [createElement("span", {
                            children: [`Virus: ${scan.Filename}`],
                        })], ["children", reactApi.Children.toArray(Array.from(elems_20))])))), createElement("span", {
                            style: {
                                whiteSpace: "pre",
                            },
                            children: scan.Description,
                        })], ["children", reactApi.Children.toArray(Array.from(elements_7))])]);
                    }
                }, virus)));
            })), ["children", reactApi.Children.toArray(Array.from(elems_22))])]))));
        }))))));
    })))), ["children", reactApi.Children.toArray(Array.from(elements_8))])]), (children_9 = toList(delay(() => append((errorMsg == null) ? singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "outlined"], ["disabled", processing], ["children", updated ? ctx.Locale.t("Cancel") : ctx.Locale.t("Close")], ["onClick", (_arg_8) => {
        if (updated) {
            console.debug("Cancel edit/update");
            iterate((input) => {
                input.value = document$.Title;
            }, toArray_1(titleRef.current));
            setForm(UploadModule_docToRevisionForm(document$));
            setUpdated(false);
        }
        else {
            handleClose();
        }
    }]])) : empty(), delay(() => {
        let elems_24, elems_25;
        return singleton(MuiHelpers_createElement(Button, [["size", "small"], ["variant", "contained"], ["disabled", !updated], ["startIcon", processing ? loadingIndicatorSmall() : (uploaded ? createElement("div", createObj(ofArray([["style", {
            color: "#FFFFFF",
        }], (elems_24 = toList(delay(() => {
            if ((errorMsg == null) && (virus.length === 0)) {
                return singleton(createElement(Components_TimedProgress_ZB2B7FD7, {
                    onEnd: () => {
                        handleClose();
                    },
                    closeTimeMs: 1500,
                }));
            }
            else if (virus.length > 0) {
                console.warn(some("We found suspicious files in your upload! Signing you out."));
                return singleton(createElement(Components_TimedProgress_ZB2B7FD7, {
                    onEnd: () => {
                        RouterModule_nav(singleton_1("signout"), 1, 1);
                    },
                    closeTimeMs: 4000,
                }));
            }
            else {
                return singleton(defaultOf_1());
            }
        })), ["children", reactApi.Children.toArray(Array.from(elems_24))])]))) : defaultOf_1())], ["onClick", (_arg_9) => {
            let properties_2;
            if (uploaded) {
                handleClose();
            }
            else {
                const url = API_Document_Document(parse_3(document$.Guid));
                const changeReasonOpt = bind((elem) => tryStr(elem.value), changeReasonRef.current);
                if (changeReasonOpt != null) {
                    const reason = changeReasonOpt;
                    setProcessing(true);
                    let pr_2;
                    let pr_1;
                    const item = new DocumentRevisionForm(form.DocumentId, form.DocumentNumber, form.Version, form.Title, form.Filename, form.Content, form.ContentSizeBytes, form.RevisionDate, form.IsHidden, form.CategoryTreeId, form.ManuallyMoved, reason);
                    const data = some(Auto_generateBoxedEncoder_437914C6(DocumentRevisionForm_$reflection(), undefined, undefined, undefined)(item));
                    const decoder = Auto_generateBoxedDecoder_Z6670B51(DocumentScanResult_$reflection(), undefined, undefined);
                    const data_1 = data;
                    const caseStrategy_3 = undefined;
                    const extra_3 = undefined;
                    try {
                        const properties_3 = Helper_withProperties(corsProps, (properties_2 = ofArray([new Types_RequestProperties(0, ["PUT"]), new Types_RequestProperties(1, [keyValueList(Helper_withContentTypeJson(data_1, empty_1()), 0)])]), defaultArg(map_2((data_1_1) => cons(new Types_RequestProperties(2, [toString_2(0, Auto_generateBoxedEncoderCached_437914C6(obj_type, unwrap(caseStrategy_3), unwrap(extra_3))(data_1_1))]), properties_2), data_1), properties_2)));
                        const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Helper_fetch(url, properties_3).then((_arg) => {
                            let response_1, decoder_1_1;
                            return ((response_1 = _arg, (decoder_1_1 = defaultArg(decoder, Auto_generateBoxedDecoderCached_Z6670B51(DocumentScanResult_$reflection(), unwrap(caseStrategy_3), unwrap(extra_3))), PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (((response_1.ok) ? PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (response_1.text().then((_arg_1) => {
                                let matchValue_1;
                                return Promise.resolve((matchValue_1 = fromString(uncurry2(decoder_1_1), _arg_1), (matchValue_1.tag === 1) ? (new FSharpResult$2(1, [new FetchError(1, [matchValue_1.fields[0]])])) : (new FSharpResult$2(0, [matchValue_1.fields[0]]))));
                            })))) : (Promise.resolve(new FSharpResult$2(1, [new FetchError(2, [response_1])])))).then((_arg_1_1) => (Promise.resolve(_arg_1_1)))))))));
                        }))));
                        pr_1 = (pr.then(void 0, ((arg) => (new FSharpResult$2(1, [new FetchError(3, [arg])])))));
                    }
                    catch (exn) {
                        pr_1 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(new FSharpResult$2(1, [new FetchError(0, [exn])])))));
                    }
                    pr_2 = (pr_1.then((res) => mapFetchError((statusCode) => {
                        let maxUploadDocumentCount, maxUploadDocumentSize;
                        switch (statusCode) {
                            case 401:
                                return ctx.Locale.t("Document.MissingPermission");
                            case 413:
                                return (maxUploadDocumentCount = int32ToString(Documents_maxUploadDocumentCount), (maxUploadDocumentSize = int32ToString(~~(Documents_maxUploadSizeKB / 1000)), ctx.Locale.t("Document.DocumentsTooLarge", ((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})((((x,a)=>{let o=(x||{});o[a[0]]=a[1];return o})(defaultOf(),["maxUploadDocumentCount", maxUploadDocumentCount])),["maxUploadDocumentSize", maxUploadDocumentSize]))));
                            default:
                                return ctx.Locale.t("Document.UploadFailed");
                        }
                    }, res)));
                    pr_2.then((scanResults) => {
                        if (scanResults.tag === 1) {
                            const err_1 = scanResults.fields[0];
                            console.error(some("Failed scanning documents"), err_1);
                            if (filelistRef.current != null) {
                                const input_2 = value_314(filelistRef.current);
                                input_2.value = "";
                            }
                            setErrorMsg(err_1);
                        }
                        else if (scanResults.fields[0].tag === 1) {
                            const docOpt = tryHead(scanResults.fields[0].fields[0]);
                            if (docOpt != null) {
                                const doc_2 = docOpt;
                                console.debug("Got new document from virus scanning:", doc_2);
                                updatedDocRef.current = doc_2;
                                setForm(UploadModule_docToRevisionForm(doc_2));
                                setMeta(new FormMeta(doc_2.Uploaded, doc_2.Uploader, document$.ContentSizeBytes));
                            }
                            else {
                                console.error(some("Uploaded document for scanning but no documents got returned"));
                            }
                        }
                        else {
                            setVirus(scanResults.fields[0].fields[0]);
                        }
                        setUploaded(true);
                        setProcessing(false);
                    });
                }
                else {
                    patternInput_8[1]("Du må oppgi grunn for å endre dokumentet");
                }
            }
        }], (elems_25 = toList(delay(() => (uploaded ? singleton(createElement("span", {
            style: {},
            children: ctx.Locale.t("Close"),
        })) : singleton(ctx.Locale.t("Document.Upload"))))), ["children", reactApi.Children.toArray(Array.from(elems_25))])]));
    })))), MuiHelpers_createElement(DialogActions, [["children", reactApi.Children.toArray(Array.from(children_9))]]))], ["children", reactApi.Children.toArray(Array.from(elements_10))])]);
}

export function Upload_EditButton_13687765(upload_EditButton_13687765InputProps) {
    let props_1;
    const customerAttachment = upload_EditButton_13687765InputProps.customerAttachment;
    const treeId = upload_EditButton_13687765InputProps.treeId;
    const document$ = upload_EditButton_13687765InputProps.document;
    const onClose = upload_EditButton_13687765InputProps.onClose;
    const customerId = upload_EditButton_13687765InputProps.customerId;
    const key = upload_EditButton_13687765InputProps.$key;
    const customerAttachment_1 = defaultArg(customerAttachment, false);
    const patternInput = reactApi.useState(false);
    const setOpen = patternInput[1];
    const xs = [createElement(Upload_EditForm_Z6F414B8D, {
        key: key,
        $key: key,
        isOpen: patternInput[0],
        customerId: customerId,
        onClose: (docOpt) => {
            setOpen(false);
            if (docOpt != null) {
                onClose(value_314(docOpt));
            }
        },
        document: document$,
        treeId: unwrap(treeId),
        customerAttachment: customerAttachment_1,
    }), MuiHelpers_createElement(IconButton, [["size", "small"], ["children", (props_1 = {}, react.createElement(Edit, props_1))], ["onClick", (_arg) => {
        setOpen(true);
    }]])];
    return react.createElement(react.Fragment, {}, ...xs);
}

